import { AlphaSCircleIcon } from './AlphaSCircleIcon';

/**
 * author: Contributors
 * id 2F13C710-300C-4287-9320-C84024C1002D
 * name alpha-s-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-s-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterSCircleIcon = AlphaSCircleIcon;
export default LetterSCircleIcon